import { BookingChangeStatus } from '@/features/dashboard/bookingChanges/types/dto/BookingChangeStatus.ts';

/**
 * Paczka otwarta = jeszcze niewprowadzona i niezamknięta. Ten sam zbiór, który
 * po stronie backendu pilnuje reguły „co najwyżej jedna otwarta paczka edycji
 * na rezerwację” (`BookingChangeStatus.OPEN_STATUSES`) i który rozstrzyga, czy
 * wolno pytać o podglądy paczki.
 */
export const OPEN_CHANGE_STATUSES: BookingChangeStatus[] = [
  BookingChangeStatus.DRAFT,
  BookingChangeStatus.PENDING_CLIENT,
];

export const isOpenChangeStatus = (
  status: BookingChangeStatus | undefined,
): boolean => !!status && OPEN_CHANGE_STATUSES.includes(status);
